<script setup>
/* Imports */
import {
  watch,
  onMounted,
  ref,
} from 'vue';

/* Store */
import { useGlobalStore } from '../store/global.js';

/* Components */
import AppHeader from '../containers/AppHeader.vue';
import StickyMenu from '../containers/StickyMenu.vue';
import AppBody from '../containers/AppBody.vue';

/* Composables */
import { useScreenSize } from '../composables/useScreenSize.js';

/* Init Composables */
const { screenSizeWidth } = useScreenSize();

/* Init store */
const globalStore = useGlobalStore();

/* State */
const state = ref({
  maxProducts: null,
});

/* in range */
const inRange = (num, min, max) => num >= min && num <= max;

/* Get max products */
const getMaxProducts = (width) => {
  let productCount = 2;

  if (width >= 1020) {
    productCount = 5;
  }
  if (inRange(width, 820, 1019)) {
    productCount = 4;
  }
  if (inRange(width, 610, 819)) {
    productCount = 3;
  }
  if (width <= 609) {
    productCount = 2;
  }

  state.value.maxProducts = productCount;
};

/* Watch: re-calc max products if width changes */
watch(screenSizeWidth, (width) => {
  getMaxProducts(width);
});

/* Mount */
onMounted(() => getMaxProducts(screenSizeWidth.value));
</script>

<template>
  <div
    id="main"
    class="main"
  >
    <AppHeader />

    <StickyMenu
      :products="globalStore.getProductData?.products"
      :max-products="state.maxProducts"
    />
    <AppBody
      id="app-body"
      :specs="globalStore.getProductData?.productSpecs"
      :max-products="state.maxProducts"
    />
  </div>
</template>

<style lang="scss">
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  margin: 0;

  @media (min-width: $compare-screen-small) {
    padding: 1.5rem;
  }
}

.container-inner {
  display: flex;
  flex-flow: column nowrap;
  max-width: 1024px;
  padding: 0 1rem;
  margin-left: auto;
  margin-right: auto;
}

#app-body {
  position: relative;
  padding-bottom: 3rem;
}
</style>
